// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"b24c87f5","503":"741f536c","710":"2d3c70cd","911":"27e58133"}[chunkId] + ".chunk.js";
};